import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  SyntheticEvent,
} from "react";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { IconButton } from "@mui/material";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { getInitFormData, getTablebySql } from "@shared/utils/CommonUtils";
import SnTab from "@shared/components/SnTab";
import { Box, TextField, Typography } from "@mui/material";
import SnButton from "@shared/components/SnButton";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import formCtrl from "./JsonData/formCtrl.json";
import { TpCtrlList } from "@shared/type/CommonType";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  type: string;
  columnsData: any[];
  gridData: any;
  modalRef?: any; // 부모 엘리먼트
  isPopup?: boolean;
}

const DesignerSearchEdit = forwardRef(
  (
    {
      type,
      columnsData,
      gridData = {
        title: "",
        table: "",
        button: "",
        buttonNode: null,
      },
      modalRef,
      isPopup,
    }: Props,
    ref
  ) => {
    const gridApiRef = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const { userInfo } = global();
    const [girdcolumns, setGridColumns] = useState<any[]>(formCtrl.formCtrl);
    const [parentref, setParentref] = useState<any>(null);
    const selectedTabPage = useRef<any>(1);
    const [form, setForm] = useState(gridData);
    const [options, setOptions] = useState<any[]>(gridData.columnsInfo || []);
    const [initOption, setInitOption] = useState<any[]>(
      gridData.filterColumns || []
    );

    useEffect(() => {
      if (modalRef?.current) {
        setParentref(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const jscomboctrl = TpCtrlList.map((v) => ({
        code: v,
        name: v,
      }));

      const newColumns = formCtrl.formCtrl.map((column: any) => {
        if (column.cd_column === "tp_ctrl") {
          return {
            ...column,
            js_combo: jscomboctrl,
          };
        }
        return column;
      });
      setGridColumns(newColumns);
    }, []);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        gridApiRef.current.stopEditing();

        const button = convertButton(form.button); // 버튼 변환
        const updatedData: any[] = [];
        gridApiRef.current.forEachNode((node: any) => {
          updatedData.push(node.data);
        });
        return [updatedData, { ...form, buttonNode: button }];
      },
    }));

    const onGridBtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };
    const onAddRow = async () => {
      try {
        const line = gridApiRef.current.getMaxValue("no_line") + 1;
        const seq = gridApiRef.current.getMaxValue("no_seq") + 1;
        const newRow = {
          no_line: line,
          cd_firm: userInfo.cd_firm,
          no_seq: seq,
        };
        gridApiRef.current?.addRow(newRow);
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      if (gridApiRef.current?.getDisplayedRowCount() < 1) {
        return;
      }
      gridApiRef.current?.deleteSelectedRows();
    };

    const search = async (value: string) => {
      const param = {
        id: "com_drawing_02",
        params: {
          cd_firm: userInfo.cd_firm,
          nm_label: value,
        },
      };
      const rtn: any = await fnGetDataSet(param);
      const line = gridApiRef.current.getMaxValue("no_line") + 1;
      const seq = gridApiRef.current.getMaxValue("no_seq") + 1;
      const newrow = rtn[0][0];
      newrow.no_line = line;
      newrow.no_seq = seq;

      gridApiRef.current?.addRow(newrow);
    };

    const handleChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, checked } = e.target;
      setForm({ ...form, [name]: checked });
    };

    const onGridBtnClick = (key: string) => {
      if (key.includes("적용")) {
      } else alert(key);
    };

    const convertButton = (value: string) => {
      if (value == null || value == "") return null;
      const buttonLabels = value
        .split(",")
        .map((label) => label.trim())
        .filter((label) => label);

      const nodes = buttonLabels.map((label) => (
        <SnButton
          key={label}
          text={label}
          onClick={() => onGridBtnClick(label)}
        />
      ));
      return nodes;
    };

    const convertDefaultValue = (str: string) => {
      return str
        .split(",")
        .map((pair) => pair.trim())
        .filter(Boolean)
        .reduce(
          (acc, cur) => {
            const [key, value] = cur.split(":").map((s) => s.trim());
            if (key) acc[key] = value ?? "";
            return acc;
          },
          {} as Record<string, string>
        );
    };
    const setColumnsInfo = async () => {
      const columnsInfo = await getColumnsInfo(form.table);
      setForm({ ...form, columnsInfo: columnsInfo });
      if (columnsInfo && Array.isArray(columnsInfo)) {
        setOptions(columnsInfo);
      }
    };

    const getColumnsInfo = async (tablename: string) => {
      try {
        const search = {
          queryId: "getColumnsInfo",
          id: "DesignerMapper",
          params: {
            table_name: tablename,
          },
        };
        const data: any = await fnGetDataSet(search);
        return data[0];
      } catch (error) {}
    };

    const onTabChanged = (tabIndex: any) => {
      selectedTabPage.current = tabIndex;
    };

    const filterChange = (e: SyntheticEvent, value: any) => {
      const filterColumns = value.map((option: any) => option.column_name);
      setForm({ ...form, filterColumns: filterColumns });
      setInitOption(filterColumns);
    };

    return (
      <div>
        <SnTab
          titles={["컨트롤"]}
          width={"100%"}
          onTabChanged={onTabChanged}
          body={[
            <div>
              <div className="w-[1438px] h-[600px]">
                <SnGrid
                  ref={gridApiRef} // Grid Name
                  columnConfig={girdcolumns} // 컬럼 설정 전달
                  rowData={
                    columnsData.length === 1 &&
                    Object.keys(columnsData[0]).length === 0
                      ? []
                      : columnsData
                  }
                  etcProps={{ popupParent: parentref }}
                  events={{ onBtnAddClick: onGridBtnClick }}
                />
              </div>
            </div>,
          ]}
          header={[
            <div ref={parentref} className="flex items-center justify-between">
              {/* 좌측: 검색 및 SnTextBox */}
              <div className="flex items-center">
                <span className="mr-8">검 색</span>
                <div className="w-[300px]">
                  <TextField
                    fullWidth
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        style: {
                          height: StyleSettings.control_height,
                          fontSize: StyleSettings.font,
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        search((e.target as HTMLInputElement).value);
                      }
                    }}
                  />
                </div>
              </div>
              {/* 우측: IconButton들 */}
              <div className="flex items-center">
                <div className="ml-2">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("addRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/new_off.svg)",
                      backgroundSize: "cover",
                      width: 30,
                      height: 30,
                      "&:hover": {
                        backgroundImage: "url(/images/new_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
                <div className="ml-5 mr-4">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("deleteRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/delete_off.svg)",
                      backgroundSize: "cover",
                      width: 25,
                      height: 25,
                      "&:hover": {
                        backgroundImage: "url(/images/delete_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
              </div>
            </div>,
            null,
          ]}
        />
      </div>
    );
  }
);

export default DesignerSearchEdit;
